export const testQuestion = [
    {
    "mcid" : "00809875",
    "access" : "1",
    "gameMode" : "1",
    "areaVar" : "adl",
    "availableyears" : "2019,2018,2017,2016,2015,2014,2013,2012",
    "admin" : "Y",
    "questionText" : "<p>A 52-year-old man with a history of lung cancer has a 5 cm adrenal mass with an attenuation of 45 Hounsfield units noted on follow-up non-contrast CT scan. Metastatic evaluation is otherwise negative. Metabolic evaluation is normal. The next step is:</p>",
    "questionID" : "3866",
    "QuestionYear" : "2019",
    "questionArea" : "ADL",
    "patientType" : "ADU",
    "questionNumber" : "3",
    "qoptions" : [
     
    {
    "AnswerOptionID" : 19327,
    "AnswerOption" : "repeat imaging and metabolic evaluation in six months. ",
    "AnswerOptionLetter" : "A",
    "AnswerOptionCorrect" : "0"
    },
    {
    "AnswerOptionID" : 19328,
    "AnswerOption" : "MRI scan. ",
    "AnswerOptionLetter" : "B",
    "AnswerOptionCorrect" : "0"
    },
    {
    "AnswerOptionID" : 19329,
    "AnswerOption" : "MIBG scan. ",
    "AnswerOptionLetter" : "C",
    "AnswerOptionCorrect" : "0"
    },
    {
    "AnswerOptionID" : 19326,
    "AnswerOption" : "percutaneous needle biopsy. ",
    "AnswerOptionLetter" : "D",
    "AnswerOptionCorrect" : "1"
    },
    {
    "AnswerOptionID" : 19330,
    "AnswerOption" : "adrenalectomy. ",
    "AnswerOptionLetter" : "E",
    "AnswerOptionCorrect" : "0"
    }
    ]
    }
    ]

